/**
 * Beta Invitation API Service
 */

import { BetaInvitationForm, BetaInvitationSubmitResponse } from '../types/betaInvitation';
import { parseApiError } from '../utils/errorHandler';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export const betaInvitationService = {
  /**
   * Submit a beta invitation application
   */
  async submitApplication(data: BetaInvitationForm): Promise<BetaInvitationSubmitResponse> {
    try {
      const response = await fetch(`${API_BASE_URL}/web/beta-invitations/submit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        const parsedError = parseApiError({
          detail: errorData.detail,
          status_code: response.status,
        });

        // Throw with error code for better handling
        const error = new Error(parsedError.message);
        (error as any).code = parsedError.code;
        (error as any).originalMessage = errorData.detail;
        throw error;
      }

      return await response.json();
    } catch (error: any) {
      console.error('Error submitting beta invitation:', error);

      // If error doesn't have a code, parse it
      if (!error.code) {
        const parsedError = parseApiError(error);
        error.code = parsedError.code;
      }

      throw error;
    }
  },
};
